//
// PreferredSizeRequestEvent.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";
import "../events/PortableEvent";

var PreferredSizeRequestEvent = createModule("commons::PreferredSizeRequestEvent", ["commons::PortableEvent"], ClosetObject, [
    {
        PREFERRED_WIDTH_REQUEST: 20046,
        MINIMUM_HEIGHT_REQUEST: 20051,
        WIDTH_REQUEST: 20048,
        PREFERRED_HEIGHT_REQUEST: 20047,
        HEIGHT_REQUEST: 20049,
        MINIMUM_WIDTH_REQUEST: 20050,
    },
    ,
    ,
    ,
    {
        getConstrainedSize: [5],
    },
    ,
    ,
]);
export default PreferredSizeRequestEvent;
